<template>
    <div class="main">
        <!-- <div id="wave" class="wave" v-wave> -->
        <div>
            <swiper :options="swiperOption">
                <swiper-slide v-for="(value,index) in lbt" :key="index">
                    <img :src="value.images" />
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
            <!-- <h1>海南搜易科技有限公司</h1> -->
        </div>
        <div class="serviceSupport">
            <p class="title1">SERVICE SUPPORT</p>
            <p class="title2">服務支持</p>
            <div class="supportDom">
                <div class="supListItem"></div>
                <div class="supListItem links">
                    <router-link to="/clay">
                        <p>
                            粘土
                            <br />
                            <span class="line"></span>
                        </p>
                    </router-link>
                </div>
                <div class="supListItem"></div>
                <div class="supListItem links">
                    <router-link to="/figma">
                        <p>
                            Figma
                            <br />
                            <span class="line"></span>
                        </p>
                    </router-link>
                </div>
                <div class="supListItem"></div>
                <div class="supListItem links">
                    <router-link to="/voucher">
                        <p>
                            Mycard點卡
                            <br />
                            <span class="line"></span>
                        </p>
                    </router-link>
                </div>
            </div>
        </div>
        <mask></mask>
    </div>
</template>

<script>
//import wave from './canvas'
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import banner1 from '../../static/img/banner.png'
import mask from '@/components/mask'
export default {
    name: 'HelloWorld',
    components: {
        swiper,
        swiperSlide,
        mask
    },
    data() {
        return {
            swiperOption: {
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                slidesPerView: 1,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
                observer: true, //修改swiper自己或子元素时，自动初始化swiper
                observeParents: true, //修改swiper的父元素时，自动初始化swiper
            },
            lbt: [
                {
                    images: banner1,
                },
            ],
        }
    },
    methods: {
        lunbo() {
            new swiper('.swiper-container', {
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
            })
        },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main >>> .swiper-pagination-bullet-active{
    background: #f08200;
}
#wave {
    width: 100%;
    height: 960px;
    position: relative;
}
h1 {
    color: white;
    font-size: 60px;
    position: absolute;
    text-align: center;
    z-index: 99;
    top: 43%;
    width: 100%;
}
.main {
    position: relative;
    top: 0;
    left: 0;
}
.main .banner_wrap {
    overflow: hidden;
}
.main .banner_wrap,
.swiper-container {
    width: 100%;
}
.main .banner_wrap,
.swiper-container img {
    width: 100%;
}
.swiper-container img {
    display: inherit !important;
}
.serviceSupport {
    background: url('../../static/img/bg.jpg') no-repeat;
    background-size: 100% 100%;
    width: 100%;
    height: 960px;
    text-align: center;
}
.title1 {
    font-size: 55px;
    color: #f7c6c2;
    margin: 0;
    padding-top: 100px;
    letter-spacing: 3px;
}
.title2 {
    font-size: 30px;
    font-weight: 600;
    color: #ff5f31;
    margin: 0;
    margin-top: -15px;
    letter-spacing: 3px;
}
.supportDom {
    display: flex;
    width: 1200px;
    height: 505px;
    flex-flow: row wrap;
    margin: 0 auto;
    margin-top: 100px;
    -moz-box-shadow: 0px 0px 15px #999; /* 老的 Firefox */
    box-shadow: 0px 0px 15px #999;
}
.supListItem {
    width: 33.3333333%;
    height: 50%;
    flex-shrink: 0;
    background-color: rgb(100, 100, 100);
}
.supListItem a {
    width: 100%;
    color: white;
    text-decoration: none;
}
.links {
    background-color: #ff7c54;
    color: white;
    font-size: 22px;
    display: flex;
    opacity: 0.7;
    cursor: pointer;
}
.links p {
    flex-shrink: 0;
    width: 100%;
    text-align: center;
    margin-top: 120px;
    line-height: 15px;
}
.line {
    width: 0px;
    height: 3px;
    background-color: white;
    flex-shrink: 0;
    display: inline-block;
    transition: width 0.5s;
}

.links:hover .line {
    width: 120px;
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue